<div class="flex gap-4" id="thread_alert">
  <sbnb-reservation-icon></sbnb-reservation-icon>

  <sbnb-split-card class="flex-1" [imgSrc]="message.listing?.image" [imgHeadine]="message.listing?.name">
    <div class="flex flex-col gap-4 p-6">
      <h3>Pending Quote</h3>
      <div class="flex flex-col gap-3">
        <div class="flex gap-2">
          <img src="/assets/iconography/check-in.svg" alt="Check in icon" />
          <span>{{ startDate | date: "EEE, LLL d ''yy" }}</span>
        </div>
        <div class="flex gap-2">
          <img src="/assets/iconography/check-out.svg" alt="Check out icon" />
          <span>{{ endDate | date: "EEE, LLL d ''yy" }}</span>
        </div>

        <div *ngIf="message.revenue && (hasFinancialPermissions$ | async)" class="flex gap-2">
          <img src="/assets/iconography/subtotal.svg" alt="Subtotal" />
          <span>{{ message.currency_code }}{{ message.revenue }}</span>
        </div>

        <div class="flex gap-2">
          <div *ngIf="message.num_adults" class="flex gap-2">
            <ui-icon icon="adults" class="text-smoke-darker"></ui-icon>
            <span>{{ message.num_adults }}</span>
          </div>
          <div *ngIf="message.num_children > 0" class="flex gap-2">
            <img src="/assets/iconography/kids.svg" alt="Children" />
            <span>{{ message.num_children }}</span>
          </div>
          <div *ngIf="message.num_infants > 0" class="flex gap-2">
            <img src="/assets/iconography/infants.svg" alt="Children" />
            <span>{{ message.num_infants }}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap-reverse gap-3 justify-between">
        <sbnb-button
          label="Cancel"
          type="secondary"
          [loading]="rejectLoading"
          (clicked)="reject.emit(message)"></sbnb-button>

        @if (requiresHostReview()) {
          <sbnb-button label="Review" type="primary-grape" (clicked)="openReviewDialog()"></sbnb-button>
        } @else if (message.payment_provider === 'adyen' && message.payment_status === 'authorised') {
          Verification incomplete
        } @else if (message.payment_status !== 'authorised' && message.payment_status !== 'captured') {
          Awaiting payment
        }
      </div>
    </div>
  </sbnb-split-card>
</div>
